import { Base64 } from 'js-base64'

import {GetparkProgressBar} from '@/graphql/queries/Park.graphql'
import {GetParkNote} from '@/graphql/queries/ParkNote.graphql'
import {CreateParkNote} from '@/graphql/mutations/ParkNote.graphql'

export default {
  apollo : {
    parkProgressBar : {
      query : GetparkProgressBar,
      variables(){
        return {
          park_id  : this.parkId
        };
      },
      skip(){
        if(typeof this.parkId === 'undefined'){
          return true;
        }else{
          return false;
        }
      }
    }
  },

  methods : {
    async submitBehaviour(){
      this.$store.dispatch({
        type            : 'textEditorWarningModal/updateOpenModal',
        isSubmitLoading : true,
      });

      await this.UXWaiting(1000);

      this.$store.dispatch({
        type            : 'textEditorWarningModal/updateOpenModal',
        value           : false,
        isSubmitLoading : false
      });

      const textCounter = this.editorData.onlyText.replace(/\s/g, '').length;

      let result = false;

      switch(this.editorBehaviour){
        case 'new':
         result = await this.executeInsertParkNote({
            parkId      : this.parkId,
            title       : this.titleData,
            body        : Base64.encode(JSON.stringify(this.editorData.delta)),
            text        : this.editorData.onlyText,
            textCounter : textCounter,
          });
        break;

        case 'edit':
          result = await this.executeEditParkNote({
            parkNoteId  : this.parkNoteId,
            title       : this.titleData,
            body        : Base64.encode(JSON.stringify(this.editorData.delta)),
            text        : this.editorData.onlyText,
            textCounter : textCounter,
          });
        break;
      }

      this.$store.dispatch({
        type  : 'parkNote/updateIsEditorLoading',
        value : false,
      });

      if(result !== false){
        // 現在保存されている変数上のデータを削除します。
        this.titleData  = '';
        this.editorData = null;
        this.defaultTitle           = '';
        this.defaultBodyDeltaString = '';

        // モーダルを閉じます。
        this.handleCloseModal();

        this.isLoadingSubmitButton = false;
        this.isDisableCancelButton = false;

        // ステータスバーを更新
        this.$apollo.queries.parkProgressBar.refetch();

        this.$store.dispatch({
          type        : 'flashMessage/updateFlashMessage',
          hasMessage  : true,
          message     : '&nbsp;ノートを掲示しました。',
          status      : 'primary',
          hasControl  : true,
          autoClose   : 3000
        }, {root:true});

        // 新規の場合は作成したノートに飛びます。
        if(this.editorBehaviour === 'new'){
          this.$router.push({
            name    : 'parks.note.detail',
            params  : {
              noteId: result.id,
              parkId: result.park.id
            },
          });
        }
      }
    },

    async cancelBehaviour(){
      this.$store.dispatch({
        type  : 'textEditorWarningModal/updateOpenModal',
        value : false,
      });

      this.$store.dispatch({
        type  : 'parkNote/updateIsEditorLoading',
        value : false,
      });

      this.isLoadingSubmitButton = false;
      this.isDisableCancelButton = false;
    },

    executeInsertParkNote(payload){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : CreateParkNote,
          variables : {
            parkId      : payload.parkId,
            title       : payload.title,
            body        : payload.body,
            text        : payload.text,
            textCounter : payload.textCounter
          },
          update    : (store, {data: {CreateParkNote}}) => {
            if(CreateParkNote !== null){
              store.writeQuery({
                query     : GetParkNote,
                variables : {
                  id  : CreateParkNote.id
                },
                data      : {
                  parkNote : CreateParkNote
                }
              });
            }
          }
        }).then(async ({data: {CreateParkNote}}) => {
          this.$apollo.queries.draftParkNoteFromParkId.refetch();
          
          resolve(CreateParkNote);
        }).catch(async (error) => {
          const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(error);

          if(typeof simpleErrorSet.firstError.field !== 'undefined'){
            const errorMessageTextSet = {
              'default'                               : "エラーが発生しました。",
              'Could not enough character ink body'   : "&nbsp;インクが足りません。",
              'This text include In-Acceptable wrod.' : "&nbsp;こちらの内容はご投稿いただくことができかねます。",
            };

            let errorMessageText = '';

            switch(simpleErrorSet.firstError.field){
              case 'title':
              case 'body':
                if(typeof errorMessageTextSet[simpleErrorSet.firstError.message] !== 'undefined'){
                  errorMessageText = errorMessageTextSet[simpleErrorSet.firstError.message];
                }else{
                  errorMessageText = errorMessageTextSet['default'];
                }
              break;
            }

            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : errorMessageText,
              status      : 'error',
              hasControl  : true,
              autoClose   : 3000
            }, {root:true});
          }

          resolve(false);
        });
      });
    },

    async executeSubmitButton(){
      this.$store.dispatch({
        type  : 'parkNote/updateIsEditorLoading',
        value : true,
      });

      await this.UXWaiting(800);

      if( this.shouldSkipWarningModal() ){
        await this.submitBehaviour();
      }else{
        this.$store.dispatch({
          type                  : 'textEditorWarningModal/updateOpenModal',
          value                 : true,
          handleSubmitFunction  : this.submitBehaviour,
          handleCancelFunction  : this.cancelBehaviour
        });
      }
    },

    async executeCancelButton(){
      await this.UXWaiting(800);

      // 下書き機能が使える場合は閉じる前に下書き保存します。
      if(this.isEnableDraftFunction === true){
        await this.saveDraftParkNote();
      }
    }
  }
}